import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
export default {
  name: "daily",
  //每日签到
  computed: {
    ...walletVuex.mapState(["isMobile", "theme", "setting"])
  }
};